export const environment = {
  production: false,
  apiUrl: 'https://sky-group-erp-middleware-platform.middleware.sky/suppliersearch/api/suppliers',
  appUrl: 'https://sky.uat.supplier.middleware.sky',
  authority: 'https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237',
  clientId: 'a0868be6-e6c1-487b-aab5-0ea3d414dc7e',
  apiScope: 'api://e4d87765-4baf-4107-8b08-de4714204d63/access_as_user'
};
